module.exports = __webpack_public_path__ + "img/pay-in-full-icon.091e5b82.svg";